module.exports = __webpack_public_path__ + "static/media/MBSP_logo.c392b765.png";